import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HardwareSignupCard from '../../../HardwareSignupCard/HardwareSignupCard';
import { getHWPrinterFeatureTranslation } from '../../../../../../utils/HardwareInclusive/HardwareInclusive';
import HardwareInclusiveModalCard from '../../HardwareInclusiveModal/HardwareInclusiveModalCard/HardwareInclusiveModalCard';
import HardwareInclusiveModal from '../../HardwareInclusiveModal/HardwareInclusiveModal';
import { formatNumberOnLocale } from '../../../../../../constants/AppMethod';
import currencies from '../../../../../../constants/CurrencyTypes';

const DisplayHardware = (props) => {
  const {
    printerFeatures,
    handleSelectionChange,
    selectedData,
    selectedDeviceType,
  } = props;

  const { t } = useTranslation(["translation"]);

  const [modalState, setModalState] = useState(false);
  const toggleModal = () => {
    setModalState(!modalState);
  }
  const onModalSelect = (value) => {
    handleSelectionChange(value)
    setModalState(false)
  }

  const renderCard = (feature) => (
    <HardwareSignupCard
      key={feature?.featureId}
      id={feature?.featureId}
      onHardwarePlanSelection={handleSelectionChange}
      selectedCard={selectedData?.featureId}
      toCompareSelectedCardWith={feature?.featureId}
      selectionPayload={feature}
      displayMoreInfo={() => toggleModal()}
      cardInfo={false} //hiding the modal temporarily, will be enabled as part of improvement ticket
      cardRightData={getHWPrinterFeatureTranslation(
        feature?.featureId,
        feature?.featureName,
        selectedDeviceType
      )}
      cardLeftData={
        <div className='cp-price-wrapper'>
          <span
            className={
              feature?.price ? "discount-price" : "normal-price"
            }
          >
            {formatNumberOnLocale(
              feature?.discountedPrice,
              currencies[feature?.currency]?.code
            )}
          </span>
          {feature?.price && (
            <>
              &nbsp;
              <span className="actual-price">
                {formatNumberOnLocale(
                  feature?.price,
                  currencies[feature?.currency]?.code
                )}
              </span>
            </>
          )}
        </div>
      }
    />
  );

  return (
    <div className="cp-printer-feature-wrapper">
      <div className="cp-subtitle">
        {t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.HARDWARE_TYPE.CHOOSE_HARDWARE")}
      </div>

      <div className="cp-card">
        {printerFeatures?.map((feature) => {
          return (
            <React.Fragment key={feature.featureId}>
              {/* ****************HIDING THE SUB_HEADER, will be enabled in the future improvement ticket
              {Number(selectedDeviceType) ===
                DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE &&
                !feature.featureName.includes("A3") &&
                feature?.featureId === 1 && (
                  <div className="cp-subsection-title first">
                    {t(
                      "HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.HARDWARE_TYPE.NEW_PRINTER_BUNDLE.A4_PRINT"
                    )}
                  </div>
                )}

              {Number(selectedDeviceType) ===
                DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE &&
                feature.featureName.includes("A3") &&
                feature?.featureId === 2 && (
                  <div className="cp-subsection-title">
                    {t(
                      "HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.HARDWARE_TYPE.NEW_PRINTER_BUNDLE.A4_A3_PRINT"
                    )}
                  </div>
                )} */}

              {renderCard(feature)}
            </React.Fragment>
          );
        })}
      </div>

      <HardwareInclusiveModal
        modalState={modalState}
        toggleModal={toggleModal}
        modalHeader={t(
          "HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.HARDWARE_TYPE.NEW_PRINTER_BUNDLE.A4_A3_PRINT_OUTPUT"
        )}
      >
        {printerFeatures
          ?.filter(
            (f) => f?.featureName?.includes("A3") && f?.featureId !== 1
          )
          ?.map((feature) => (
            <HardwareInclusiveModalCard
              key={feature?.featureId}
              value={feature}
              onModalSelect={onModalSelect}
              title={getHWPrinterFeatureTranslation(
                feature?.featureId,
                feature?.featureName,
                selectedDeviceType
              )}
              info={`${t("MY_DEVICES.DEVICE_DETAILS.MODEL")} ${feature?.model}`}
              price={
                <div className='cp-price-wrapper'>
                  <span className="discount-price">
                    {formatNumberOnLocale(
                      feature?.discountedPrice,
                      currencies[feature?.currency]?.code
                    )}
                  </span>
                  &nbsp;
                  {feature?.price && (
                    <span className="actual-price">
                      {formatNumberOnLocale(
                        feature?.price,
                        currencies[feature?.currency]?.code
                      )}
                    </span>
                  )}
                </div>
              }
              image={feature?.deviceImageUrl}
            />
          ))}
      </HardwareInclusiveModal>
    </div>
  );
};

export default DisplayHardware;